import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import CDDUserDocuments from '../../features/CDD/CDDUserDocuments';

const CDDUserDocumentsPage = () => {
  const { userKey } = useParams();

  if (userKey) {
    return (
      <CDDUserDocuments userKey={userKey} eventNamePrefix="m.user-documents" />
    );
  }

  return <Navigate to="/401" replace />;
};

export default CDDUserDocumentsPage;
